import { Loader } from '../../../../shared/components/Loader';
import Box from '@mui/material/Box';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../shared/components/Input';
import { InputSelect } from '../../../../shared/components/InputSelect';
import { OPTIONS_TIPO_MAQUINA } from '../../../../shared/utils/const/TipoMaquinaOptions';
import { SelectAutoCompleteComponent } from '../../../../shared/components/SelectAutoCompleteComponent';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import useMaquinaCadastrar from '../../../../hooks/useMaquinaCadastrar';
import { useParams, useLocation } from 'react-router-dom';

export default function MaquinaCadastrar() {

  const { id } = useParams();
  const MaquinaId = id ? parseInt(id) : undefined;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  console.log(id);
  const {
    handleBlur,
    handleChange,
    handleSubmit,
    backActions,
    values,
    errors,
    touched,
    loading,
    marcaOptions,
    modeloOptions,
    handleSearchMarca,
    handleSelectMarca,
    handleSearchModelo,
    handleSelectModelo,
  } = useMaquinaCadastrar(MaquinaId);

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'Cadastro de Máquinas'} />
      <Box className='p-3'>
        <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
          <Box className='grid grid-cols-12 gap-7 pt-4'>

            <Box className='col-span-6'>
              <HeaderFormActions backActions={() => backActions()} duploClick={duploClick} />

            </Box>

            <Typography className='col-span-4' variant='h6'>
              Dados para cadastro:
            </Typography>
          </Box>

          <fieldset disabled={duploClick}>
            <Box className='grid grid-cols-12 gap-7 pt-4'>
              <Input
                label='Descrição'
                className='col-span-12'
                name='Descricao'
                handleBlur={handleBlur}
                handleChange={handleChange}
                value={values.Marca && values.Modelo && values.NumeroSerie
                  ? `${values.Marca.toUpperCase()} ${values.Modelo.toUpperCase()} ${values.NumeroSerie}`
                  : values.Descricao.toUpperCase()}
                multiline={true}
                disabled={true}
              />
              <SelectAutoCompleteComponent
                label='Marca'
                name='Marca'
                size='small'
                className='col-span-3'
                handleBlur={handleBlur}
                value={values.Marca ?? ''}
                options={marcaOptions}
                handleSearch={handleSearchMarca}
                onSelectValue={handleSelectMarca}
                error={touched.Marca && errors.Marca ? errors.Marca : ''}
                hasError={!!(touched.Marca && errors.Marca)}
              />
              <SelectAutoCompleteComponent
                label='Modelo'
                name='Modelo'
                size='small'
                className='col-span-3'
                handleBlur={handleBlur}
                value={values.Modelo ?? ''}
                options={modeloOptions}
                handleSearch={handleSearchModelo}
                onSelectValue={handleSelectModelo}
                error={touched.Modelo && errors.Modelo ? errors.Modelo : ''}
                hasError={!!(touched.Modelo && errors.Modelo)}
              />
              <Input
                label='Número de Série'
                className='col-span-3'
                name='NumeroSerie'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.NumeroSerie && errors.NumeroSerie ? errors.NumeroSerie : ''}
                hasError={!!(touched.NumeroSerie && errors.NumeroSerie)}
                value={values.NumeroSerie?.toUpperCase()}
              />
              <InputSelect
                label='Tipo'
                className='col-span-3'
                name='TipoMaquina'
                items={OPTIONS_TIPO_MAQUINA}
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={!!(touched.TipoMaquina && errors.TipoMaquina)}
                helperText={touched.TipoMaquina && errors.TipoMaquina ? errors.TipoMaquina : ''}
                value={values?.TipoMaquina ?? ''}
                size='small'
              />
              <Input
                label='Grupo'
                className='col-span-3'
                name='Grupo'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.Grupo && errors.Grupo ? errors.Grupo : ''}
                hasError={!!(touched.Grupo && errors.Grupo)}
                value={values?.Grupo}
                disabled={true}
              />
              <Input
                label='Observação'
                className='col-span-12'
                name='Observacao'
                handleBlur={handleBlur}
                handleChange={handleChange}
                error={touched.Observacao && errors.Observacao ? errors.Observacao : ''}
                hasError={!!(touched.Observacao && errors.Observacao)}
                value={values?.Observacao}
                multiline={true}
              />
            </Box>
          </fieldset>
        </form>
      </Box>
    </Loader>
  );
}
